import React from 'react'

import { Outlet } from 'react-router-dom'

import { useAppSelector } from '../../common/hooks'
import { selectIsInFrame } from '../../features/dashboard'
import { Footer } from '../Footer/Footer'
import { Header } from '../Header'

import style from './Layout.module.css'

export const Layout = () => {
  const isInFrame = useAppSelector(selectIsInFrame)

  return (
    <div className={style.layout}>
      {!isInFrame && <Header />}
      <main>
        <div className="container">
          <Outlet />
        </div>
      </main>
      {!isInFrame && <Footer />}
    </div>
  )
}
